// extracted by mini-css-extract-plugin
export default {"wrap":"IF-z","fullWidth":"JF-z","hideOnDesktop":"KF-z","content":"LF-z","hasOpenedNav":"MF-z","crumbsList":"NF-z","dropdownsWrap":"OF-z"};